import { render, staticRenderFns } from "./industrial-demo.vue?vue&type=template&id=09792843&scoped=true"
import script from "./industrial-demo.vue?vue&type=script&lang=js"
export * from "./industrial-demo.vue?vue&type=script&lang=js"
import style0 from "./industrial-demo.vue?vue&type=style&index=0&id=09792843&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09792843",
  null
  
)

export default component.exports